// // // import ContactSection from "../../components/ContactForm";
// // // import Header from "../../components/Header";
// // // import HeroSection from "../../components/HeroSection";
// // // import ServicesSection from "../../components/Services";
// // // import StepSection from "../../components/ServicesSection";


// // // export default function PrePress() {
// // //   const stepsData = [
// // //     {
// // //       title: "File Preparation",
// // //       description: "We ensure that all your files are properly formatted, optimized, and ready for printing. This step includes checking resolution, color mode, and image placement."
// // //     },
// // //     {
// // //       title: "Color Management",
// // //       description: "Our expert color management ensures the correct color output in your final print. We work with various color profiles to make sure your prints are vibrant and consistent."
// // //     },
// // //     {
// // //       title: "Proofing & Approval",
// // //       description: "Before proceeding to production, we provide proofing services to make sure everything meets your expectations. Once approved, we move on to the next step in the process."
// // //     }
// // //   ];
// // //   return (
// // //     <div className="font-body">
// // //       <Header />

// // //       <section className="relative py-10 md:py-20 bg-gradient-to-br from-primary-dark to-primary-base">
// // //       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // //         <div className="text-center">
// // //           {/* Decorative elements */}
// // //           <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-8">
// // //             <span className="bg-clip-text text-transparent bg-gradient-to-r from-accent-base to-accent-light">
// // //             Pre Press
// // //             </span>
// // //           </h1>
// // //         </div>
// // //       </div>
// // //    </section>

// // //       {/* Pre-Press Intro Section */}
// // //       <section className="py-16 bg-neutral-light">
// // //         <div className="max-w-7xl mx-auto text-center px-4 sm:px-6 lg:px-8">
// // //           <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary-base mb-4">
// // //             What is Pre-Press?
// // //           </h2>
// // //           <p className="text-lg text-secondary-600 max-w-3xl mx-auto mb-8">
// // //             Pre-Press is a crucial phase in the printing process where the necessary steps are taken to prepare your design files for high-quality printing. This includes color management, file preparation, proofing, and ensuring that everything meets the required specifications before production.
// // //           </p>
// // //         </div>
// // //       </section>

// // //       {/* Steps in Pre-Press Section */}
// // //       {/* <section className="pb-16 bg-white">
// // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // //           <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary-base text-center mb-10">
// // //             Steps in the Pre-Press Process
// // //           </h2>
// // //           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
// // //             <div className="bg-white border border-primary-100 p-6 rounded-xl shadow-lg">
// // //               <h3 className="text-2xl font-semibold text-primary-base mb-4">File Preparation</h3>
// // //               <p className="text-secondary-600 text-md">
// // //                 We ensure that all your files are properly formatted, optimized, and ready for printing. This step includes checking resolution, color mode, and image placement.
// // //               </p>
// // //             </div>
// // //             <div className="bg-white border border-primary-100 p-6 rounded-xl shadow-lg">
// // //               <h3 className="text-2xl font-semibold text-primary-base mb-4">Color Management</h3>
// // //               <p className="text-secondary-600 text-md">
// // //                 Our expert color management ensures the correct color output in your final print. We work with various color profiles to make sure your prints are vibrant and consistent.
// // //               </p>
// // //             </div>
// // //             <div className="bg-white border border-primary-100 p-6 rounded-xl shadow-lg">
// // //               <h3 className="text-2xl font-semibold text-primary-base mb-4">Proofing & Approval</h3>
// // //               <p className="text-secondary-600 text-md">
// // //                 Before proceeding to production, we provide proofing services to make sure everything meets your expectations. Once approved, we move on to the next step in the process.
// // //               </p>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section> */}
// // //        <StepSection
// // //         stepsTitle="Steps in the Pre-Press Process"
// // //         steps={stepsData}
// // //       />

      

// // //       <ServicesSection />

// // //       {/* Benefits of Pre-Press Section */}
// // //       {/* <section className="py-16 bg-primary-100">
// // //         <div className="max-w-7xl mx-auto text-center px-4 sm:px-6 lg:px-8">
// // //           <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary-base mb-6">
// // //             Why Pre-Press Services Matter
// // //           </h2>
// // //           <p className="text-lg text-black max-w-3xl mx-auto mb-8">
// // //             Pre-Press services ensure that your final print product meets the highest standards of quality, color accuracy, and consistency. By catching potential issues early in the process, we can prevent costly mistakes and delays.
// // //           </p>
// // //           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
// // //             <div className="bg-white p-6 rounded-xl shadow-lg">
// // //               <h3 className="text-2xl font-semibold text-primary-base mb-4">Cost-Effective</h3>
// // //               <p className="text-secondary-600 text-lg">
// // //                 By ensuring your files are correctly prepared and proofed before printing, we reduce the chances of expensive reprints.
// // //               </p>
// // //             </div>
// // //             <div className="bg-white p-6 rounded-xl shadow-lg">
// // //               <h3 className="text-2xl font-semibold text-primary-base mb-4">Quality Assurance</h3>
// // //               <p className="text-secondary-600 text-lg">
// // //                 Pre-Press ensures your prints are of the highest quality. From color accuracy to resolution, every aspect is checked and approved.
// // //               </p>
// // //             </div>
// // //             <div className="bg-white p-6 rounded-xl shadow-lg">
// // //               <h3 className="text-2xl font-semibold text-primary-base mb-4">Time Savings</h3>
// // //               <p className="text-secondary-600 text-lg">
// // //                 Pre-Press helps streamline the process by catching mistakes before production, saving time in the long run and ensuring a smooth workflow.
// // //               </p>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section> */}

// // //       {/* Testimonials / Case Studies Section */}
// // //       {/* <section className="py-16 bg-primary-50">
// // //         <div className="max-w-7xl mx-auto text-center px-4 sm:px-6 lg:px-8">
// // //           <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary-base mb-6">
// // //             Client Success Stories
// // //           </h2>
// // //           <div className="flex flex-wrap justify-center gap-8">
// // //             <div className="bg-white border border-primary-100 p-8 rounded-xl shadow-lg w-full sm:w-96">
// // //               <h3 className="text-xl font-semibold text-primary-base mb-4">Company A</h3>
// // //               <p className="text-secondary-600 text-lg mb-4">
// // //                 "The Pre-Press team was incredible! Their attention to detail and color management made all the difference. We were able to meet tight deadlines with top-notch quality prints."
// // //               </p>
// // //             </div>
// // //             <div className="bg-white border border-primary-100 p-8 rounded-xl shadow-lg w-full sm:w-96">
// // //               <h3 className="text-xl font-semibold text-primary-base mb-4">Company B</h3>
// // //               <p className="text-secondary-600 text-lg mb-4">
// // //                 "Working with the Pre-Press team ensured that our print materials were flawless. Their proofing process saved us time and money, and we couldn’t be happier with the results."
// // //               </p>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section> */}

// // //       {/* Contact Section */}
// // //       <ContactSection />
// // //     </div>
// // //   );
// // // }


import ContactSection from "../../components/ContactForm";
import Header from "../../components/Header";

import { motion } from 'framer-motion';
import { Printer, FileCheck, Palette, CheckCircle, ArrowRight, Award, Clock, Shield } from 'lucide-react';
import { Link, useLocation } from "react-router-dom";

import HeroSection from "../../components/HeroSection";
import ServicesSection from "../../components/Services";
import StepSection from "../../components/ServicesSection";
import bannerImg from "../../assets/freepik__expand__64108.png"
import Footer from "../../components/Footer";
import { useEffect } from "react";
export default function PrePress() {

    const { pathname } = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const steps = [
    {
      icon: <FileCheck className="w-12 h-12 text-primary-base" />,
      title: "File Preparation",
      description: "We ensure that all your files are properly formatted, optimized, and ready for printing. This includes checking resolution, color mode, and image placement."
    },
    {
      icon: <Palette className="w-12 h-12 text-primary-base" />,
      title: "Color Management",
      description: "Our expert color management ensures the correct color output in your final print. We work with various color profiles to make sure your prints are vibrant and consistent."
    },
    {
      icon: <CheckCircle className="w-12 h-12 text-primary-base" />,
      title: "Proofing & Approval",
      description: "Before proceeding to production, we provide proofing services to make sure everything meets your expectations. Once approved, we move on to the next step in the process."
    }
  ];

  const benefits = [
    {
      icon: <Award className="w-8 h-8" />,
      title: "Quality Assurance",
      description: "Guaranteed excellence in every print through rigorous quality control processes"
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: "Fast Turnaround",
      description: "Quick and efficient service without compromising on quality"
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "100% Satisfaction",
      description: "We work until you're completely satisfied with the final result"
    }
  ];

  const stepsData = [
    {
      title: "File Preparation",
      description: "We ensure that all your files are properly formatted, optimized, and ready for printing. This step includes checking resolution, color mode, and image placement."
    },
    {
      title: "Color Management",
      description: "Our expert color management ensures the correct color output in your final print. We work with various color profiles to make sure your prints are vibrant and consistent."
    },
    {
      title: "Proofing & Approval",
      description: "Before proceeding to production, we provide proofing services to make sure everything meets your expectations. Once approved, we move on to the next step in the process."
    }
  ];
  return (
    <div className="font-body">
      <Header />

      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-primary-dark to-primary-base py-20 lg:py-32">
        <div className="absolute inset-0 bg-grid-white/[0.2] bg-[size:16px]" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            className="text-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-8">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-accent-base to-accent-light">
                Pre-Press Excellence
              </span>
            </h1>
            <p className="text-xl text-neutral-200 max-w-2xl mx-auto mb-8">
              Transform your designs into print-ready masterpieces with our professional pre-press services
            </p>
           
           {/* <Link to="/contact">
            <button className="bg-accent-base hover:bg-accent-light text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl">
             Get Started Today
            </button>
            </Link> */}
              <Link to="/contact">
                <button className="bg-accent-base hover:bg-accent-light text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl">
                Get Started Today
                </button>
              </Link>
          </motion.div>
        </div>
      </section>

       {/* What is Pre-Press Section */}
       <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            className="text-center mb-15"
            {...fadeIn}
          >
             <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base mb-4">
            What is Pre-Press?
          </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Pre-Press is where precision meets creativity. It's the crucial phase where we transform your design files into print-ready perfection through advanced color management, meticulous file preparation, and comprehensive quality control.
            </p>
          </motion.div>
        </div>
      </section>
       {/* Process Steps */}
       <section className="py-20 bg-neutral-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base text-4xl font-bold text-center text-primary-base mb-16">
            Our Pre-Press Process
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <motion.div 
                key={index}
                className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2 }}
              >
                <div className="mb-6">{step.icon}</div>
                <h3 className="text-2xl font-bold text-primary-base mb-4">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-base text-4xl font-bold text-center text-primary-base mb-16">
            Why Choose Our Pre-Press Services?
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <motion.div 
                key={index}
                className="p-6 rounded-xl bg-neutral-50 hover:bg-neutral-100 transition-colors duration-300"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.2 }}
              >
                <div className="flex items-center mb-4 text-primary-base">
                  {benefit.icon}
                  <h3 className="text-xl font-bold ml-3">{benefit.title}</h3>
                </div>
                <p className="text-gray-600">{benefit.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

            {/* Call to Action */}
            <section className="py-20 bg-gradient-to-br from-primary-dark to-primary-base text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white text-4xl font-bold mb-8">Ready to Get Started?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Let's transform your design into print-ready perfection. Our expert team is ready to help you achieve outstanding results.
          </p>

          <Link to="/contact">
                <button className="bg-accent-base hover:bg-accent-light text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 flex items-center mx-auto">
                Contact Us Today
                <ArrowRight className="ml-2 w-5 h-5" />
                </button>
              </Link>
        </div>
      </section>

  

      <ServicesSection />

      {/* Contact Section */}
      <ContactSection />
      <Footer />
    </div>
    
  );
}

// import React from 'react';
// import { motion } from 'framer-motion';
// import { Printer, FileCheck, Palette, CheckCircle, ArrowRight, Award, Clock, Shield } from 'lucide-react';
// import ContactSection from "../../components/ContactForm";
// import Header from "../../components/Header";
// import ServicesSection from "../../components/Services";

// const PrePress = () => {
//   // Animated SVG background pattern
//   const GridPattern = () => (
//     <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
//       <defs>
//         <pattern id="grid" width="32" height="32" patternUnits="userSpaceOnUse">
//           <path d="M0 32V0h32" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="1"/>
//         </pattern>
//       </defs>
//       <rect width="100%" height="100%" fill="url(#grid)" />
//     </svg>
//   );

//   const steps = [
//     {
//       icon: <FileCheck className="w-16 h-16" />,
//       title: "File Prep",
//       color: "from-blue-500 to-blue-600"
//     },
//     {
//       icon: <Palette className="w-16 h-16" />,
//       title: "Color",
//       color: "from-purple-500 to-purple-600"
//     },
//     {
//       icon: <CheckCircle className="w-16 h-16" />,
//       title: "Proof",
//       color: "from-green-500 to-green-600"
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800">
//       <Header />

//       {/* Hero Section */}
//       <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-gray-900 via-primary-dark to-primary-base">
//         <GridPattern />
//         <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
//           <motion.div 
//             className="grid lg:grid-cols-2 gap-12 items-center"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ duration: 1 }}
//           >
//             <div>
//               <motion.h1 
//                 className="text-6xl lg:text-8xl font-bold mb-6"
//                 initial={{ x: -100, opacity: 0 }}
//                 animate={{ x: 0, opacity: 1 }}
//                 transition={{ delay: 0.2 }}
//               >
//                 <span className="bg-clip-text text-transparent bg-gradient-to-r from-accent-base via-accent-light to-accent-base">
//                   Pre-Press
//                 </span>
//               </motion.h1>
//               <motion.div 
//                 className="flex gap-4"
//                 initial={{ y: 50, opacity: 0 }}
//                 animate={{ y: 0, opacity: 1 }}
//                 transition={{ delay: 0.4 }}
//               >
//                 <button className="bg-accent-base hover:bg-accent-light text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl">
//                   Start Project
//                 </button>
//                 <button className="bg-white/10 hover:bg-white/20 text-white font-bold py-4 px-8 rounded-xl transition-all duration-300">
//                   Learn More
//                 </button>
//               </motion.div>
//             </div>
            
//             {/* Animated Graphic */}
//             <motion.div 
//               className="relative h-96"
//               initial={{ scale: 0.8, opacity: 0 }}
//               animate={{ scale: 1, opacity: 1 }}
//               transition={{ delay: 0.6 }}
//             >
//               <div className="absolute inset-0 bg-gradient-to-r from-accent-base to-accent-light rounded-2xl transform rotate-6 opacity-20" />
//               <div className="absolute inset-0 bg-gradient-to-r from-primary-base to-primary-dark rounded-2xl transform -rotate-3 opacity-40" />
//               <img
//                 src="/api/placeholder/600/400"
//                 alt="Pre-Press Visual"
//                 className="relative rounded-2xl shadow-2xl w-full h-full object-cover"
//               />
//             </motion.div>
//           </motion.div>
//         </div>
//       </section>

//       {/* Process Steps - Visual Cards */}
//       <section className="py-32 bg-gray-900">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid md:grid-cols-3 gap-8">
//             {steps.map((step, index) => (
//               <motion.div 
//                 key={index}
//                 className={`relative group overflow-hidden rounded-2xl bg-gradient-to-br ${step.color}`}
//                 initial={{ opacity: 0, y: 50 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.2 }}
//               >
//                 <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-20 transition-opacity duration-300" />
//                 <div className="p-8 h-64 flex flex-col items-center justify-center text-white">
//                   <motion.div 
//                     className="mb-6 transform group-hover:scale-110 transition-transform duration-300"
//                     whileHover={{ rotate: 360 }}
//                     transition={{ duration: 0.8 }}
//                   >
//                     {step.icon}
//                   </motion.div>
//                   <h3 className="text-2xl font-bold text-center">{step.title}</h3>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Interactive Feature Section */}
//       <section className="py-32 bg-gradient-to-br from-gray-900 to-gray-800">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <motion.div 
//             className="grid lg:grid-cols-2 gap-12 items-center"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ duration: 0.8 }}
//           >
//             <div className="space-y-8">
//               <motion.div 
//                 className="bg-white/5 p-6 rounded-xl hover:bg-white/10 transition-colors duration-300"
//                 whileHover={{ scale: 1.05 }}
//               >
//                 <Award className="w-8 h-8 text-accent-base mb-4" />
//                 <h3 className="text-xl font-bold text-white">Premium Quality</h3>
//               </motion.div>
//               <motion.div 
//                 className="bg-white/5 p-6 rounded-xl hover:bg-white/10 transition-colors duration-300"
//                 whileHover={{ scale: 1.05 }}
//               >
//                 <Clock className="w-8 h-8 text-accent-base mb-4" />
//                 <h3 className="text-xl font-bold text-white">Fast Turnaround</h3>
//               </motion.div>
//               <motion.div 
//                 className="bg-white/5 p-6 rounded-xl hover:bg-white/10 transition-colors duration-300"
//                 whileHover={{ scale: 1.05 }}
//               >
//                 <Shield className="w-8 h-8 text-accent-base mb-4" />
//                 <h3 className="text-xl font-bold text-white">Guaranteed Results</h3>
//               </motion.div>
//             </div>
            
//             <motion.div 
//               className="relative h-96"
//               initial={{ x: 100, opacity: 0 }}
//               animate={{ x: 0, opacity: 1 }}
//               transition={{ delay: 0.4 }}
//             >
//               <div className="absolute inset-0 bg-gradient-to-r from-accent-base to-accent-light rounded-2xl transform rotate-3 opacity-20" />
//               <img
//                 src="/api/placeholder/600/400"
//                 alt="Features Visual"
//                 className="relative rounded-2xl shadow-2xl w-full h-full object-cover"
//               />
//             </motion.div>
//           </motion.div>
//         </div>
//       </section>

//       {/* Call to Action */}
//       <section className="py-20 bg-gradient-to-br from-accent-base to-accent-light">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <motion.button 
//             className="bg-white text-accent-base font-bold py-6 px-12 rounded-xl text-xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//           >
//             Start Your Project
//             <ArrowRight className="inline ml-2 w-6 h-6" />
//           </motion.button>
//         </div>
//       </section>

//       <ServicesSection />
//       <ContactSection />
//     </div>
//   );
// };

// export default PrePress;

// import React, { useState, useEffect } from 'react';
// import { motion, useScroll, useTransform } from 'framer-motion';
// import { 
//   Printer, FileCheck, Palette, CheckCircle, ArrowRight, 
//   Award, Clock, Shield, ChevronRight, Play, Pause
// } from 'lucide-react';
// import ContactSection from "../../components/ContactForm";
// import Header from "../../components/Header";
// import ServicesSection from "../../components/Services";

// const PrePress = () => {
//   const [activeStep, setActiveStep] = useState(0);
//   const [isPlaying, setIsPlaying] = useState(true);
//   const { scrollYProgress } = useScroll();
  
//   const processSteps = [
//     {
//       icon: <FileCheck className="w-12 h-12" />,
//       title: "File Preparation",
//       color: "from-blue-500 to-blue-600",
//       gradient: "bg-gradient-to-br from-blue-500/20 to-blue-600/20"
//     },
//     {
//       icon: <Palette className="w-12 h-12" />,
//       title: "Color Management",
//       color: "from-purple-500 to-purple-600",
//       gradient: "bg-gradient-to-br from-purple-500/20 to-purple-600/20"
//     },
//     {
//       icon: <CheckCircle className="w-12 h-12" />,
//       title: "Quality Control",
//       color: "from-green-500 to-green-600",
//       gradient: "bg-gradient-to-br from-green-500/20 to-green-600/20"
//     }
//   ];

//   useEffect(() => {
//     if (isPlaying) {
//       const timer = setInterval(() => {
//         setActiveStep((prev) => (prev + 1) % processSteps.length);
//       }, 3000);
//       return () => clearInterval(timer);
//     }
//   }, [isPlaying, processSteps.length]);

//   const parallaxY = useTransform(scrollYProgress, [0, 1], ['0%', '50%']);

//   // Animated background component
//   const AnimatedBackground = () => (
//     <div className="absolute inset-0 overflow-hidden">
//       <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-primary-dark to-primary-base opacity-90" />
//       <motion.div 
//         className="absolute inset-0"
//         style={{ y: parallaxY }}
//       >
//         <div className="w-full h-full bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-accent-base/20 via-primary-base/10 to-transparent" />
//       </motion.div>
//       <div className="absolute inset-0">
//         <svg className="w-full h-full opacity-[0.05]" viewBox="0 0 100 100">
//           <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
//             <path d="M 10 0 L 0 0 0 10" fill="none" stroke="white" strokeWidth="0.5"/>
//           </pattern>
//           <rect width="100" height="100" fill="url(#grid)" />
//         </svg>
//       </div>
//     </div>
//   );

//   return (
//     <div className="min-h-screen bg-gray-900">
//       <Header />

//       {/* Hero Section */}
//       <section className="relative min-h-screen flex items-center overflow-hidden">
//         <AnimatedBackground />
//         <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
//           <div className="grid lg:grid-cols-2 gap-16 items-center">
//             <motion.div
//               initial={{ opacity: 0, x: -100 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.8 }}
//             >
//               <h1 className="text-7xl font-bold mb-8">
//                 <span className="bg-clip-text text-transparent bg-gradient-to-r from-accent-base via-accent-light to-accent-base inline-block">
//                   Pre-Press
//                 </span>
//                 <span className="text-white block mt-2">Excellence</span>
//               </h1>
//               <div className="flex gap-6">
//                 <motion.button
//                   className="group relative px-8 py-4 bg-accent-base rounded-xl overflow-hidden"
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                 >
//                   <span className="relative z-10 text-white font-bold flex items-center">
//                     Get Started <ArrowRight className="ml-2 w-5 h-5" />
//                   </span>
//                   <div className="absolute inset-0 bg-gradient-to-r from-accent-light to-accent-base opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//                 </motion.button>
//                 <motion.button
//                   className="px-8 py-4 border border-white/20 rounded-xl text-white font-bold hover:bg-white/10 transition-colors duration-300"
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                 >
//                   Learn More
//                 </motion.button>
//               </div>
//             </motion.div>

//             <motion.div
//               className="relative h-96"
//               initial={{ opacity: 0, scale: 0.8 }}
//               animate={{ opacity: 1, scale: 1 }}
//               transition={{ duration: 0.8, delay: 0.2 }}
//             >
//               <div className="absolute inset-0 bg-gradient-to-r from-accent-base to-accent-light rounded-3xl transform rotate-6 opacity-20" />
//               <div className="absolute inset-0 bg-gradient-to-r from-primary-base to-primary-dark rounded-3xl transform -rotate-3 opacity-40" />
//               <motion.div
//                 className="relative h-full rounded-3xl overflow-hidden shadow-2xl bg-gradient-to-br from-gray-800 to-gray-900"
//                 whileHover={{ scale: 1.02 }}
//                 transition={{ duration: 0.3 }}
//               >
//                 <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-accent-base/30 via-transparent to-transparent" />
//                 <div className="absolute inset-0 flex items-center justify-center">
//                   <Printer className="w-24 h-24 text-white/20" />
//                 </div>
//               </motion.div>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Interactive Process Section */}
//       <section className="py-32 relative overflow-hidden">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex flex-col lg:flex-row gap-16 items-center">
//             <motion.div 
//               className="lg:w-1/2"
//               initial={{ opacity: 0, x: -50 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.6 }}
//               viewport={{ once: true }}
//             >
//               <div className="relative aspect-square rounded-3xl overflow-hidden">
//                 <div className={`absolute inset-0 transition-all duration-500 ${processSteps[activeStep].gradient}`} />
//                 <div className="absolute inset-0 flex items-center justify-center">
//                   <motion.div
//                     key={activeStep}
//                     initial={{ scale: 0.8, opacity: 0 }}
//                     animate={{ scale: 1, opacity: 1 }}
//                     exit={{ scale: 0.8, opacity: 0 }}
//                     className="text-white"
//                   >
//                     {processSteps[activeStep].icon}
//                   </motion.div>
//                 </div>
//               </div>
//             </motion.div>

//             <div className="lg:w-1/2">
//               <div className="flex justify-between items-center mb-8">
//                 <h2 className="text-4xl font-bold text-white">Our Process</h2>
//                 <button 
//                   onClick={() => setIsPlaying(!isPlaying)}
//                   className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
//                 >
//                   {isPlaying ? <Pause className="w-6 h-6 text-white" /> : <Play className="w-6 h-6 text-white" />}
//                 </button>
//               </div>
              
//               <div className="space-y-6">
//                 {processSteps.map((step, index) => (
//                   <motion.div
//                     key={index}
//                     className={`p-6 rounded-xl cursor-pointer transition-all duration-300 ${
//                       activeStep === index ? 'bg-white/10' : 'bg-white/5 hover:bg-white/8'
//                     }`}
//                     onClick={() => setActiveStep(index)}
//                     whileHover={{ scale: 1.02 }}
//                   >
//                     <div className="flex items-center justify-between">
//                       <div className="flex items-center gap-4">
//                         <div className={`w-12 h-12 rounded-full flex items-center justify-center bg-gradient-to-br ${step.color}`}>
//                           {step.icon}
//                         </div>
//                         <h3 className="text-xl font-bold text-white">{step.title}</h3>
//                       </div>
//                       <ChevronRight className={`w-6 h-6 text-white transition-transform duration-300 ${
//                         activeStep === index ? 'rotate-90' : ''
//                       }`} />
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Features Grid */}
//       <section className="py-32 bg-gradient-to-br from-gray-900 to-gray-800">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {[
//               { icon: <Award />, title: "Premium Quality" },
//               { icon: <Clock />, title: "Fast Turnaround" },
//               { icon: <Shield />, title: "Guaranteed Results" }
//             ].map((feature, index) => (
//               <motion.div
//                 key={index}
//                 className="group relative p-8 rounded-2xl bg-white/5 overflow-hidden"
//                 initial={{ opacity: 0, y: 50 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.1 }}
//                 viewport={{ once: true }}
//                 whileHover={{ scale: 1.02 }}
//               >
//                 <div className="absolute inset-0 bg-gradient-to-br from-accent-base/20 to-accent-light/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//                 <div className="relative z-10">
//                   <div className="w-12 h-12 rounded-full bg-accent-base/20 flex items-center justify-center mb-4">
//                     <div className="text-accent-base">
//                       {feature.icon}
//                     </div>
//                   </div>
//                   <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-20 relative overflow-hidden">
//         <div className="absolute inset-0 bg-gradient-to-br from-accent-base to-accent-light opacity-90" />
//         <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <motion.div
//             initial={{ opacity: 0, y: 50 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             viewport={{ once: true }}
//           >
//             <h2 className="text-4xl font-bold text-white mb-8">Ready to Get Started?</h2>
//             <motion.button
//               className="px-12 py-6 bg-white rounded-xl text-accent-base font-bold text-xl shadow-xl"
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               Start Your Project
//             </motion.button>
//           </motion.div>
//         </div>
//       </section>

//       <ServicesSection />
//       <ContactSection />
//     </div>
//   );
// };

// export default PrePress;